import { render, staticRenderFns } from "./OverviewHeaderOpportunity.vue?vue&type=template&id=5e059531&scoped=true&"
import script from "./OverviewHeaderOpportunity.vue?vue&type=script&lang=js&"
export * from "./OverviewHeaderOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./OverviewHeaderOpportunity.vue?vue&type=style&index=0&id=5e059531&prod&lang=scss&scoped=true&"
import style1 from "./OverviewHeaderOpportunity.vue?vue&type=style&index=1&id=5e059531&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e059531",
  null
  
)

export default component.exports